var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DownLoad",
    transform: "translate(-390 -255.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    transform: "translate(390 255.118)",
    fill: "none",
    stroke: "#5dadae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(402 267.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12165",
    "data-name": "Path 12165",
    d: "M20.5,22.5v3.554a1.777,1.777,0,0,1-1.778,1.777H6.278A1.777,1.777,0,0,1,4.5,26.054V22.5",
    transform: "translate(-4.5 -11.831)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12166",
    "data-name": "Path 12166",
    d: "M10.5,15l4.446,4.442L19.392,15",
    transform: "translate(-6.946 -8.777)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12167",
    "data-name": "Path 12167",
    d: "M18,15.161V4.5",
    transform: "translate(-10 -4.5)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.79f2c3008dae535018eb65610e606a54.svg";
export { ForwardRef as ReactComponent };